import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, InputNumber, Modal, Switch, Popover, Button, message } from 'antd';
import './../CompanyManagementForm.less';
import { COMPANY_EDIT_ERROR, COMPANY_EDIT_SUCCESS } from './../../../../actions/Company';

const FormItem = Form.Item;

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    const logTime = this.props.company.logRetentionTime;
    this.state = {
      visible: false,
      logRetentionTime: logTime || 0,
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case COMPANY_EDIT_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      case COMPANY_EDIT_SUCCESS:
        message.success('Virksomheden blev redigeret.');
        this.handleCancel();
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const { onEdit } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { name, clientId, clientSecret, loggingEnabled } = values;
        const company = {
          id: this.props.company.id,
          name,
          clientId,
          clientSecret,
          loggingEnabled,
          logRetentionTime: this.state.logRetentionTime,
        };
        onEdit(company);
      }
    });
  };

  /**
   * Closes modal window.
   */
  handleCancel = () => {
    this.props.onCancel();
  };

  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };

  /**
   * Parses the input units of time into seconds.
   * @param years, months and days
   */
  handleChangeLogRetentionTime = (timeUnits) => {
    timeUnits.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { years, months, days } = values;
        days = +days;
        days += Math.floor(365 * years);
        days += Math.floor(30 * months);
        const seconds = 86400 * days;

        this.setState({ logRetentionTime: seconds });
        this.hide();
      }
    });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, textAlign: 'left' },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Modal
        width={'50%'}
        visible={this.props.visible}
        title={'Rediger virksomhed'}
        okText={'Ok'}
        cancelText={'Annuller'}
        onCancel={this.handleCancel}
        onOk={this.handleSubmit}
        confirmLoading={this.props.isLoading}
      >
        <Form>
          <FormItem {...formItemLayout} label={'Virksomhedsnavn'}>
            {getFieldDecorator('name', {
              initialValue: this.props.company.name,
              rules: [
                {
                  required: true,
                  message: 'Virksomhedsnavn skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Klientid'}>
            {getFieldDecorator('clientId', {
              label: this.props.company.clientId,
              rules: [
                {
                  message: 'Klientid skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input placeholder={this.props.company.clientId} />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Klientnøgle'}>
            {getFieldDecorator('clientSecret', {
              rules: [
                {
                  message: 'Klientnøgle skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input placeholder={this.props.company.clientSecret} />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Gem historik'}>
            {getFieldDecorator('loggingEnabled', {
              valuePropName: 'checked',
              initialValue: this.props.company.loggingEnabled,
            })(<Switch />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Log opbevaringstid'}>
            {getFieldDecorator('logTime')(
              <Popover
                placement={'topLeft'}
                content={
                  <Form onSubmit={this.handleChangeLogRetentionTime} autoComplete={'off'}>
                    <FormItem {...formItemLayout} label='År' hasFeedback>
                      {getFieldDecorator('years')(
                        <InputNumber className={'log-duration-input'} type={'number'} />
                      )}
                    </FormItem>
                    <FormItem {...formItemLayout} label='Måneder' hasFeedback>
                      {getFieldDecorator('months')(
                        <InputNumber className={'log-duration-input'} type={'number'} />
                      )}
                    </FormItem>
                    <FormItem {...formItemLayout} label='Dage' hasFeedback>
                      {getFieldDecorator('days')(
                        <InputNumber className={'log-duration-input'} type={'number'} />
                      )}
                    </FormItem>
                    <FormItem>
                      <Button onClick={this.hide}>Annuller</Button>
                      <Button type='primary' htmlType='submit'>
                        Gem
                      </Button>
                    </FormItem>
                  </Form>
                }
                trigger='click'
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
              >
                <div>
                  <Button type='link'>
                    {this.props.generateDateFromSeconds(this.state.logRetentionTime)}
                  </Button>
                </div>
              </Popover>
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditForm);
